import { render, staticRenderFns } from "./MarketplaceFinansalVeriler.vue?vue&type=template&id=f767d6e4&scoped=true"
import script from "./MarketplaceFinansalVeriler.vue?vue&type=script&lang=js"
export * from "./MarketplaceFinansalVeriler.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceFinansalVeriler.vue?vue&type=style&index=0&id=f767d6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f767d6e4",
  null
  
)

export default component.exports